<template>
    <CRow>
        <CCol col="12" sm="8" class="mx-auto">
            <CTabs v-if="user" :key="(user ? user.id : 0)">
                <CTab class="account">
                    <template #title>
                        <FaIcon @click="clearMsg" icon="user-edit" class="mfe-2" />
                        <span @click="clearMsg">{{ $t('user.authentication') }}</span>
                    </template>
                    <UserAccount :user="user" class="mt-2" />
                </CTab>
                <CTab class="account" v-if="user.role.name == 'ناشر'">
                    <template #title>
                        <FaIcon @click="clearMsg" icon="coins" class="mfe-2" />
                        <span @click="clearMsg">{{ $t('user.financial') }}</span>
                    </template>
                    <Financial :user="user" class="mt-2" />
                </CTab>
                <CTab class="account">
                    <template #title>
                        <FaIcon @click="clearMsg" icon="envelope" class="mfe-2" />
                        <span @click="clearMsg">{{ $t('setting.ad_management') }}</span>
                    </template>
                    <Notification :user="user" class="mt-2" />
                </CTab>
            </CTabs>
        </CCol>
    </CRow>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import UserAccount from './partials/UserAccount'
import Notification from './partials/Notification'
import Financial from './partials/Financial'

export default {
    name: 'Edit',

    components: {
        UserAccount,
        Notification,
        Financial,
    },

    beforeRouteEnter (to, from, next) {
        next(vm => {
            if (!(vm.user && vm.user.fetch_find)) {
                vm.setShowLoading()
                vm.find(vm.id).then(() => {
                    vm.setShowLoading(false)
                })
            }
        })
    },

    data() {
        return {
            id: this.$route.params.id,
        }
    },

    computed: {
        ...mapGetters('user', [
            'userById'
        ]),
        user() {
            const user = this.userById(this.id)

            if (user && user.sheba_number) {
                return Object.assign({}, user, {
                    sheba_number: user.sheba_number.replace(/[ir]/gmi, '')
                })
            }
            return user
        }
    },

    methods: {
        ...mapActions({
            edit: 'user/edit',
            find: 'user/find',
            setMsg: 'messageComponent/setMsg',
            resetMsg: 'messageComponent/resetMsg',
            setShowLoading: 'loadingComponent/setShowLoading'
        }),
        clearMsg() {
            this.resetMsg()
        },
    }
}
</script>

<style lang="scss" scoped>
    .account::v-deep a.nav-link {
        padding: 1rem 1rem !important;
        color: #ab007e !important; //text-affili-eggplant
        border: none !important;
        border-radius: 5px 5px 0 0 !important;
    }
    .account::v-deep a.nav-link.active {
        background-color: #ab007e !important; //bg-affili-indigo
        color: #fff !important; //text-white
    }
    .account::v-deep a.nav-link:focus,
    .account::v-deep a.nav-link:hover {
        border: none !important;
        border-radius: 5px 5px 0 0 !important;
    }
</style>